<template>
  <div>
    <div class="columns">
      <div class="column has-text-centered">
        <div class="buttons is-centered">
          <button
            v-for="(item, index) in items"
            :key="index"
            class="button"
            :class="active(index + 1, item)"
            @click="selData(index)"
          >
            {{ item.nombre }}
          </button>
          <button
            class="button is-tooltip-info tooltip"
            data-tooltip="Agregar Registro"
            v-show="fila >= 0"
            @click="agregarRegistro"
          >
            <span class="icon">
              <i class="material-icons">playlist_add</i>
            </span>
          </button>
          <button
            class="button is-tooltip-danger tooltip"
            data-tooltip="Eliminar Registro"
            v-show="fila > 0"
            @click="eliminaRegistro"
          >
            <span class="icon">
              <i class="material-icons">delete_forever</i>
            </span>
          </button>
        </div>
      </div>
    </div>
    <div class="columns">
      <dir
        class="
          column
          is-half is-offset-one-quarter
          inputregister
          inputencabezado
        "
      >
        <div class="field is-fullwidth has-addons">
          <div class="control">
            <a class="button" @click="f3">
              <span class="icon is-medium">
                <i class="material-icons">list_alt</i>
              </span>
            </a>
          </div>

          <div class="control is-expanded has-icons-left">
            <input
              id="inputItems"
              v-model="inputitem"
              @keydown="keyfunction($event)"
              class="input is-fullwidth is-primary"
              type="text"
              autocomplete="off"
            />
            <span v-show="editsel" class="icon is-small is-left">
              <i class="material-icons">edit</i>
            </span>
            <span v-show="!editsel" class="icon is-small is-left">
              <i class="material-icons">control_camera</i>
            </span>
          </div>
          <div class="control">
            <a class="button is-primary" @click="ok">
              <span class="icon">
                <i class="material-icons">done_outline</i>
              </span>
            </a>
          </div>
        </div>
      </dir>
    </div>
  </div>
</template>

<script>
export default {
  data() {
    return {
      inputitem: "",
      editsel: false,
    };
  },
  props: {
    items: Array,
    columna: Number,
    fila: Number,
    namevariable: String,
    cambio: Number,
    lengthReg: Number,
  },
  methods: {
    agregarRegistro() {
      this.$emit("newReg");
    },
    eliminaRegistro() {
      this.$emit("deleteReg", this.fila);
    },
    selData(index) {
      this.$emit("columna", index + 1);
      setTimeout(function () {
        document.getElementById("inputItems").focus();
      }, 5);
    },
    chargeData() {
      this.inputitem = this.items[this.columna - 1].input;
    },
    keyfunction(e) {
      if (e.keyCode === 121) {
        // presiona la tecka f10
        e.preventDefault();
        this.$emit("keyfunctionitem", e);
      }
      if (e.keyCode === 113) {
        // presiona la tecla f2
        e.preventDefault();
        if (this.editsel) {
          this.editsel = false;
        } else {
          this.editsel = true;
        }
      }
      if (e.keyCode === 114) {
        // presiona la tecla f3
        e.preventDefault();
        this.f3();
      }
      if (e.keyCode === 39) {
        // presiona la tecla a la derecha

        if (!this.editsel) {
          e.preventDefault();
          if (this.columna < this.items.length) {
            this.$emit("columna", this.columna + 1);
          }
        }
      }
      if (e.keyCode === 37) {
        if (!this.editsel) {
          e.preventDefault();
          if (this.columna > 1) {
            this.$emit("columna", this.columna - 1);
          }
        }
      }
      if (e.keyCode === 40) {
        if (!this.editsel) {
          e.preventDefault();
          if (this.fila === -1) {
            this.$emit("fila", this.fila + 1);
            // if (this.columna > 4) {
            //   this.$emit("columna", 4);
            // }
            setTimeout(function () {
              document.getElementById("inputItems").focus();
            }, 5);
          } else if (this.fila < this.lengthReg - 1) {
            this.$emit("fila", this.fila + 1);
            setTimeout(function () {
              document.getElementById("inputItems").focus();
            }, 5);
          } else {
            // TODO SE MANDA A TOTALES Y SE VALIDA TODO
          }
        }
      }
      if (e.keyCode === 38) {
        if (!this.editsel) {
          e.preventDefault();
          if (this.fila > -1) {
            this.$emit("fila", this.fila - 1);
            setTimeout(function () {
              document.getElementById("inputItems").focus();
            }, 5);
          }
        }
      }
      if (e.keyCode === 13 || e.keyCode === 9) {
        // que haga lo mismo con el tabulador y el enter
        e.preventDefault();
        this.ok();
      }
    },
    ok() {
      if (this.columna < this.items.length) {
        this.$emit("columna", this.columna + 1);
      } else {
        if (this.fila === -1) {
          this.$emit("columna", 1);
          this.$emit("fila", this.fila + 1);
          setTimeout(function () {
            document.getElementById("inputItems").focus();
          }, 5);
        } else if (this.fila < this.lengthReg - 1) {
          this.$emit("columna", 1);
          this.$emit("fila", this.fila + 1);
          setTimeout(function () {
            document.getElementById("inputItems").focus();
          }, 5);
        } else {
          this.$emit("llegofinal");
          // TODO aqui se valida o se manda al renglon de los totales
          // TODO Aqui se debe poner que hacer cuando llegue al final de la fila en teoria sería que verifique nuevamente todo el encabezado de la factura y si todo esta bien que pase a ver los registros y si no que muestre el error
        }
      }
    },
    f3() {
      this.$emit("f3", this.items[this.columna - 1]);
    },
    active(c, item) {
      let returned = {};
      if (c === this.columna) {
        returned["is-primary"] = true;
      } else if (item.css.status === "warning") {
        returned = {
          "is-warning": true,
        };
      } else if (item.css.status === "danger") {
        returned["is-danger"] = true;
      } else if (item.css.status === "light") {
        returned["is-light"] = true;
      }
      if (item.css.size === "small") {
        returned["is-small"] = true;
      } else if (item.css.size === "large") {
        returned["is-large"] = true;
      }
      return returned;
    },
  },
  watch: {
    columna(nv, ov) {
      this.chargeData();
      setTimeout(function () {
        document.getElementById("inputItems").select();
      }, 5);
    },
    inputitem(newv, oldv) {
      this.$emit("changeinput", {
        columna: this.columna,
        fila: this.fila,
        data: newv,
        variable: this.namevariable,
      });
    },
    cambio(nv, ov) {
      this.chargeData();
      setTimeout(function () {
        document.getElementById("inputItems").select();
      }, 5);
    },
  },
  created() {
    const _this = this;
    if (this.columna >= this.items.length) {
      this.$emit("columna", this.items.length);
      setTimeout(function () {
        _this.chargeData();
      }, 20);
    } else {
      this.chargeData();
    }
  },
};
</script>

<style lang="scss" scoped>
.inputencabezado {
  padding: 1px;
  margin-top: 1px;
}
.column {
  padding: 2px 15px 2px 15px;
}
</style>


// WEBPACK FOOTER //
// src/components/facturar/componentsfra/Formitems.vue